<app-core-hashtag-form></app-core-hashtag-form>
